import { render, staticRenderFns } from "./organization_settings.vue?vue&type=template&id=1ac138f4&"
import script from "./organization_settings.vue?vue&type=script&lang=js&"
export * from "./organization_settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports